import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Option } from '@sapphire/result';
import { match, P } from 'ts-pattern';

import {
  FEASIBILITY_ERROR_MESSAGES,
  FEASIBILITY_QUOTA_REJECTION,
} from '../../constants/feasibility.constants';

interface FeasibilityHttpFailure {
  readonly status: number;
  readonly body: string;
}

export function feasibilityErrorMessage(
  error: unknown,
  quotaLabels: readonly string[] = [],
): string {
  return httpFailureOf(error).match({
    some: ({ status, body }) =>
      rejectedQuotaLabel(body, quotaLabels).match({
        some: FEASIBILITY_ERROR_MESSAGES.QUOTA_DISTRIBUTION,
        none: () => messageForStatus(status),
      }),
    none: () => FEASIBILITY_ERROR_MESSAGES.NOT_PROCESSED,
  });
}

function messageForStatus(status: number): string {
  return !status || status >= HttpStatusCode.InternalServerError
    ? FEASIBILITY_ERROR_MESSAGES.SERVICE_UNAVAILABLE
    : FEASIBILITY_ERROR_MESSAGES.NOT_PROCESSED;
}

function rejectedQuotaLabel(
  body: string,
  quotaLabels: readonly string[],
): Option<string> {
  return Option.some(body)
    .filter((text) => text.includes(FEASIBILITY_QUOTA_REJECTION.MARKER))
    .andThen((text) =>
      Option.from(FEASIBILITY_QUOTA_REJECTION.INDEX_PATTERN.exec(text)),
    )
    .andThen(([, index]) => Option.from(quotaLabels[Number(index)]));
}

function httpFailureOf(error: unknown): Option<FeasibilityHttpFailure> {
  return match<unknown, Option<FeasibilityHttpFailure>>(error)
    .with(P.instanceOf(HttpErrorResponse), (response) =>
      Option.some({
        status: response.status,
        body: serialiseBody(response.error),
      }),
    )
    .otherwise(() => Option.none);
}

function serialiseBody(body: unknown): string {
  return match(body)
    .with(P.string, (text) => text)
    .with(P.nullish, () => '')
    .otherwise((value) => JSON.stringify(value));
}
